import { Sidebar } from "../../../../../components/sidebar/Sidebar";
import styles from "../addServiceRequest.module.css";

import React, { useEffect, useState } from "react";
import { Formik, Field, Form, useField } from "formik";
import {
  FormFieldLabel as Label,
  FormErrorLabel as ErrorLabel,
} from "../../../../../components/label/Labels";
import { FormTextArea, TextInput } from "../../../../../components/input/inputs";
import * as Yup from "yup";
import { Submit, BackButton } from "../../../../../components/button/buttons";
import FileAttachment from "../../../fileAttachment/fileAttachment.container"
import { DetailContainer } from "../../../../../components/comment/comment";
import Asterisk from "../../../../../components/asterisk/Asterisk";
import IMAGES from "../../../../../assets/images/images";
import * as DOMPurify from "dompurify";
import DropDown from "../../../../../components/dropDown/DropDown";
import Tooltip from "../../../../../components/toolTip/toolTip";
import { connect } from "react-redux";
import { openAlertPopup } from "../../../../../redux/actions/Alert/alert.action";
import { SubmitService } from "../../../../../redux/actions/incidentManagement/raiseServiceRequest.action";
import { FromLabel, MAX_FILES, MY_INCIDENT_TABS, SERVICE_REQUEST_TYPES_VALUES, ServiceImpacted, SingleMultiple, TOOLTIPS } from "../../../../../utils/constants/incidentConstants";
import { getServiceList } from "../../../../../redux/actions/incidentManagement/serviceList.action";
import { setIncidentActiveTab } from "../../../../../redux/actions/incidentManagement/incidentTab.action";
import { showErrorPopup } from "../../../../../redux/actions/customErrorPopup/customerrorpopup.action";
import { useNavigate } from "react-router-dom";
import { getModuleNotification } from "../../../../../redux/actions/notification/getModuleNotification.action";
import { renderTooltipList } from "../../../../../utils/utils";
import MultipleEmailInput from "../../../../../components/multipleEmailInput/MultipleEmailInput";
const IPX = (props) => {
  const [isSubmit, setIsSubmit] = useState(false);
  const navigate = useNavigate()

  const FieldWrapper = ({ children }) => {
    return <div className={styles.fieldWrapper}>{children}</div>;
  };
  const ButtonWrapper = ({ children }) => {
    return <div className={styles.buttonContainer}>{children}</div>;
  };

  const TextField = ({ label, placeholder,maxlength, ...props }) => {
    const [field, meta, helpers] = useField(props);
    const hasError = meta.touched && meta.error ? true : false;
    const inputStyle = hasError
      ? { ...styles.inputError, width: "250px"}
      : { width: "250px" };

    return (
      <FieldWrapper>
        <div>
          <Label text={label} style={styles.labelcompLevel}/>
          {props.name === "issue" ?<Asterisk />:<></>}<span className={styles.circlered}>
           {props.tooltiprquired == "true"? <span className={styles.tooltip} ><Tooltip text={props.tooltiptxt}/></span>:<></>}
            </span>
        </div>
        <TextInput
          {...field}
          {...props}
          placeholder={placeholder}
          style={styles.additionalStyle}
          
        />
        <div style={{display:"flex", justifyContent: hasError?"space-between":"flex-end"}}>
           {hasError ? <ErrorLabel text={meta.error} /> : null}
           {maxlength ?? <label >{maxlength}</label>}
        </div>
      </FieldWrapper>
    );
  };

  //   const FieldWrapper = ({ children }) => {
  //     return <div className={styles.fieldContainer}>{children}</div>;
  //   };

  const SelectField = ({ title, options, ...props }) => {
    let _options = options.map((item) => ({
      value: item.value,
      label: item.label,
    }));
    const [field, meta, helpers] = useField(props);


    const hasError = meta.touched && meta.error ? true : false;
    return (
      <FieldWrapper>
        <div>
          <Label text={title} style={styles.labelcompLevel}/><span className={styles.circlered}><span className={styles.tooltip}>{props.name === "ServiceImpacted"?<Asterisk/>:<></>}<Tooltip text={props.tooltiptxt}/></span></span>
        </div>
        <DropDown
          options={_options}
          customStyles={props.customStyles}
          onChange={({ label, value }) => {
            helpers.setValue(value);
          }}
          value={
            _options && field.value
              ? _options.find((option) => option.value === field.value)
              : ""
          }
          hasError={hasError}
          isDisabled={props.isDisabled}
        />
        {hasError ? <ErrorLabel text={meta.error} /> : null}
      </FieldWrapper>
    );
  };

  const TextArea = ({ label, optional = false,maxlength, ...props }) => {
    const [field, meta, helpers] = useField(props);
    const hasError = meta.touched && meta.error ? true : false;
    const inputStyle = hasError
      ? `${styles.input} ${styles.inputError}`
      : styles.input;
    return (
      <FieldWrapper>
        <div className={styles.labelcomment}>
          <Label text={label} optional={optional} style={styles.labelcompLevel}/>
          <Asterisk /><span className={styles.circlered}>
           {props.tooltiprquired == "true"? <span className={styles.tooltip} ><Tooltip text={props.tooltiptxt}/></span>:<></>}
            </span>
        </div>
        <FormTextArea {...field} {...props} style={styles.additionalStyle} />
         <div style={{display:"flex", justifyContent: hasError?"space-between":"flex-end"}}>
            {hasError ? <ErrorLabel text={meta.error} /> : null}
            {maxlength ?? <label >{maxlength}</label>}
        </div>
      </FieldWrapper>
    );
  };

  const ImageUpload = ({
    setFieldValue,
    value,
    label = "Supporting Attachments",
    ...props
  }) => {
    const [field, meta, helpers] = useField(props);
    const hasError = meta.touched && meta.error ? true : false;
    return (
      <FieldWrapper>
          <div className={styles.labelcomment}>
        <Label text={label} optional={false}style={styles.labelcompLevel} /><span className={styles.circlered}>
           {props.tooltiprquired == "true"? <span className={styles.tooltip} ><Tooltip text={props.tooltiptxt}/></span>:<></>}
            </span> </div>
        <FileAttachment
          name={props.name}
          value={value}
          setFieldValue={setFieldValue}
        />
        {hasError ? <ErrorLabel text={meta.error} /> : null}
      </FieldWrapper>
    );
  };
  let _initialValues = {
    issue: "",
    problemStatement: "",
    ServiceImpacted: "",
    SingleMultiple: "",
    IMSI: "",
    additionalEmails:[],
    files: [],
  };
   // oneitsm_api_integration: Validation interim MAX_FILES: 15 file and OneITSM MAX_FILES:1 file
  const validationSchema = Yup.object({
    issue: Yup.string().max(100, "Title must be at most 100 characters").required("Required"),
    problemStatement: Yup.string().max(1000, "Problem statement must be at most 1000 characters").required("Required"),
    ServiceImpacted: Yup.string().required("Required"),
    SingleMultiple: Yup.string(),
    IMSI: Yup.string(),
    additionalEmails: Yup.array().of(Yup.string().trim().email("Please enter a valid email address.")),
    files: Yup.array().max(MAX_FILES),
  });


  const obj = {
    width: "270px",
  };

  return (
    <Formik
      initialValues={_initialValues}
      enableReinitialize={true}
      validationSchema={validationSchema}
      validateOnChange
      onSubmit={async (values, { resetForm }) => {
        setIsSubmit(true);
        let obj = {
          serviceRequestType: props.selectedForm,
          servicesImpacted: values.ServiceImpacted,
          singleOrmultipleMsisdn: values.SingleMultiple,
          uniqueCustomerRefId:props.myRights?.customerUserMetaInfo?.uniqueCustomerRefId,
          serviceRequestDetails:{
               title: values.issue,
               problemStatement: values.problemStatement,
               IMSIDetails: values.IMSI,
               additionalEmails:values.additionalEmails,
               attachement: values.files,
          }
      };
      
        props.addService(obj).then((result) => {
            if (result.status) {
              props.openAlertPopup({
                message: `A new service request with ID: ${result?.res?.data?.ticketIdServiceDesk} has been created.`,
                image: IMAGES.success,
              });
              if(props.incidentActiveTab===MY_INCIDENT_TABS.MY_INCIDENTS){
                props.setIncidentActiveTab(MY_INCIDENT_TABS.MY_SERVICE_REQUEST);
                navigate('/incident-management/serviceRequests')
              }
              setIsSubmit(false);
              resetForm();
              props.onClose();
              props.getServiceList();
              props.getModuleNotification();
            } else {
              if(result.code === 500){
                const errormsg = <div>Service temporarily unavailable. Please try again later.<div style={{marginTop:'10px'}}>If the issue persists while using the portal, you may report it via email at cscvcs@vodafone.com with relevant details. </div></div>
                props.showErrorPopup({errorHeader:"Service Unavailable"},{errorMessage:errormsg},{isnote:true });
                setIsSubmit(false);
                }else{
              let error_msg = result?.error?.message ?? "An error occurred while processing your request. Please try again later.";  
              props.openAlertPopup({
                message: error_msg,
                image: IMAGES.error,
                isFormOpen:true
              });
            }
              setIsSubmit(false);
            //  props.onClose();
            }
          })
          .catch((error) => {
            props.openAlertPopup({
              message: "An error occurred while processing your request. Please try again later.",
              image: IMAGES.error,
              isFormOpen:true
            });
            setIsSubmit(false);
         //   props.onClose();
          });
      }}
    >
      {({ isValid,values, dirty, setFieldValue, resetForm }) => (
        <>
        <Form 
        className={styles.form}
         id="ipx_service_request"
        >   
            {props.selectedForm !== SERVICE_REQUEST_TYPES_VALUES.IPX_Services ? <hr className={styles.separatortop} />:<></>}
            <div className={styles.note}>Please Provide The Details</div>
          <TextField
            placeholder="Enter here"
            label="Title"
            name="issue"
            type="text"
            tooltiprquired="true"
            maxlength={`${values?.issue?.length}/100 characters`}
            tooltiptxt={renderTooltipList(TOOLTIPS.TITLE)}
          />
          {/* <div className={styles.commentValidation}>{`${values?.issue?.length}/100 characters`}</div> */}
          <div className={styles.dropdowngrid}>
            <div className={`${styles.dropdownwidth} ${styles.dropdownwidths}`} >
              <SelectField
                title={"Service Impacted"}
                name="ServiceImpacted"
                options={ServiceImpacted}     
                customStyles={styles.obj}
                 tooltiptxt="Service Impacted"
                //  onChange={handleServiceTypeChange}
              />
            </div>
            <div className={styles.dropdownwidth}>
              <SelectField
                title={"Single or Multiple MSISDN"}
                name="SingleMultiple"
                options={SingleMultiple}
                customStyles={styles.obj}
                 tooltiptxt="Single or Multiple MSISDN"
                //  onChange={handleServiceTypeChange}
              />
            </div>
          </div>
           <div className={styles.textbox}></div>
           <div className={styles.expandedField}>
                <MultipleEmailInput
                  name="additionalEmails"
                  label={FromLabel.additional_Email}
                  isPreviewMode={props.isIncidentPreviewModeOn}
                  requestorEmail={props?.myRights?.email}
                  showTooltip={true}
                  isNote={true}
                  tooltipText={"Additional Emails"}
                />
              </div>
          <div className={styles.textarea}>
            <TextArea
              label={"Problem Statement"}
              id="ProblemStatement"
              name="problemStatement"
              placeholder="Enter the description"
              tooltiprquired="true"
              maxlength={`${values?.problemStatement?.length}/1000 characters`}
              tooltiptxt={renderTooltipList(TOOLTIPS.PROBLEM_STATEMENT)}
            />
          </div>
          {/* <div className={styles.commentValidation}>{`${values?.problemStatement?.length}/1000 characters`}</div> */}
          <div className={styles.maintextbox}>
          <div className={styles.textbox}>
            <TextField
              placeholder="Enter IMSI number"
              label="IMSI"
              name="IMSI"
              type="text"
              tooltiptxt="IMSI"
               tooltiprquired="true"
            />
          </div>
          <div className={styles.textbox}></div>
          </div>
          <ImageUpload
            name="files"
            value={values.files}
            setFieldValue={setFieldValue}
            optional={false}
            tooltiptxt="Supporting Attachments"
            tooltiprquired="true"
          />       
        </Form>
         <div className={styles.footer}>
         <hr className={styles.separator} />
         <ButtonWrapper>
           <BackButton
             className={styles.backButton}
             style={styles.submitt}
             title={"Cancel"}
             closePopup={props.onClose}
           />
           <Submit
             id="saveButton"
             className={styles.saveButton}
             style={styles.submitivc}
             title={"Submit"}
             disabled={!isValid || !dirty}
             form="ipx_service_request"
             isSubmitting={isSubmit}
           />
         </ButtonWrapper>
         </div>
        </>
      )}
    </Formik>
  );
};


const mapStateToProps = (state) => {
  return {
    myRights:state.myRights.myRights,
    incidentActiveTab:state.incidentTab.incidentActiveTab,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    openAlertPopup: (payload) => {
        return dispatch(openAlertPopup(payload))
      },
      addService: (payload) => {
        return dispatch(SubmitService(payload))
      },
      getServiceList: (next=null)=>{
        return dispatch(getServiceList(next))
    },
    setIncidentActiveTab: (tab) => {
      return dispatch(setIncidentActiveTab(tab))
    },
    showErrorPopup: (errorHeader,errormessage,isnote) => {
      return dispatch(showErrorPopup(errorHeader,errormessage,isnote))
    },
    getModuleNotification: () => {
             return dispatch(getModuleNotification())
        },

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(IPX);


